import { initialState } from "./state"

export default {
  setLoading: (state, payload) => (state.loading = payload),
  setTypeOfferFormSelected: (state, payload) =>
    (state.typeOfferFormSelected = payload),
  setIsFromEditing: (state, payload) => (state.isFromEditing = payload),

  resetOffer: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
